import * as React from "react";
const BarChart = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { clipPath: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#3F3F3F", d: "M63.9 32.2H32.2v63.3h31.7z" }),
            React.createElement("path", { fill: "#CFCFCF", d: "M95.5.5H63.8v95h31.7z" }),
            React.createElement("path", { fill: "#ED0000", d: "M32.2 63.8H.5v31.7h31.7z" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h96v96H0z" })))));
export default BarChart;
//# sourceMappingURL=BarChart.js.map